module.exports = "/assets/98b9f3ccc7e712f73d52c0d4c8b7a210.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/J0.png
// module id = 1493
// module chunks = 0